import background from "../../../assets/images/bookDemo/background.png";
import FadeInAnimation from "../../../components/animation/FadeInAnimation";
import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import { errorDialogJPZIndex } from "../../../styles/zIndex";
import cn from "../../../utils/cn";

const dialogText = {
  systemError: "システムエラーです。",
  maintenance: "システムメンテナンス中です。",
  loginFailed: "ログインに失敗しました。",
};

export type ErrorDialogType = keyof typeof dialogText;

export default function ErrorDialogJP({
  type,
  onClose,
}: {
  type: ErrorDialogType;
  onClose: () => void;
}) {
  return (
    <div
      className={cn(
        "fixed left-0 top-0 h-screen w-screen",
        errorDialogJPZIndex,
      )}
    >
      <FadeInAnimation className="fixed bottom-0 left-0 flex h-screen w-screen items-center justify-center bg-grey8/50">
        <div className="relative w-[310px] overflow-hidden rounded-2xl bg-pink1 px-6 pb-4 pt-9 shadow-[0_0_12px_0_rgba(251,205,166,0.3)]">
          <img
            src={background}
            alt="background"
            className="absolute left-0 top-0 w-full"
          />

          <div className="relative z-10 flex flex-col items-center gap-6">
            <Text className="w-full text-center text-xl leading-[26px]">
              {dialogText[type]}
            </Text>

            <div className="pb-2">
              <Touchable
                className="flex h-[54px] items-center justify-center rounded-full bg-grey8 px-6"
                onClick={onClose}
              >
                <Text
                  lg
                  className="text-nowrap font-medium leading-[22px] text-white"
                >
                  わかりました
                </Text>
              </Touchable>
            </div>
          </div>
        </div>
      </FadeInAnimation>
    </div>
  );
}
